module.exports = __webpack_public_path__ + "static/media/chg304.e9c835e8.png";